// extracted by mini-css-extract-plugin
export default {"CardHeader":"card-header_CardHeader__ieuTs","CardHeader__titlt_mob":"card-header_CardHeader__titlt_mob__nv4xn","CardHeader__titlt_hr":"card-header_CardHeader__titlt_hr__94kOk"};